const model = "users"

const baseconfig = {
    module: model,
    sitename: '贏核數位-用户平台',
}

module.exports = baseconfig